module.exports = __webpack_public_path__ + "static/media/empty-state-upload-file.9ee9bdf9.svg";